export default __webpack_public_path__ + "fonts/ui-grid.0d23ac14ebe30a59a63cd0acdd6c607e.svg?";